import {
  StatusLight as AnvilStatusLight,
  StatusLightProps,
} from '@servicetitan/design-system';

/**
 * This component is a wrapper around the Anvil StatusLight component. For some reason the onClick and onMouseOver props are not working as expected in the Anvil component.
 * This component is a workaround to fix that issue, by wrapping the Anvil component in a div and passing the onClick and onMouseOver props to the div instead.
 * We pass a dummy function to the Anvil component to prevent the onClick and onMouseOver props so that it can still be styled correctly.
 * See the StatusLight.stories.tsx file and it's storybook for a demonstration of the issue.
 *
 * Note: I've upgraded the design system to the latest version (v14.2.4) and the issue still persists.
 *
 */
const StatusLight = ({
  children,
  onClick,
  onMouseOver,
  ...restProps
}: StatusLightProps) => {
  if (!onClick && !onMouseOver) {
    return (
      <AnvilStatusLight {...{ onClick, onMouseOver, ...restProps }}>
        {children}
      </AnvilStatusLight>
    );
  } else {
    return (
      <div onClick={onClick} onMouseOver={onMouseOver}>
        <AnvilStatusLight
          onClick={onClick === undefined ? undefined : () => {}}
          onMouseOver={onMouseOver === undefined ? undefined : () => {}}
          {...restProps}
        >
          {children}
        </AnvilStatusLight>
      </div>
    );
  }
};

export default StatusLight;
